// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__sLKFv","gfeWrapper":"CalendarEvent_gfeWrapper__17EqM"};